export { TooltipForEllipsis } from './TooltipForEllipsis';
